import { render, staticRenderFns } from "./AppBarStart.vue?vue&type=template&id=4da7f495&scoped=true"
import script from "./AppBarStart.vue?vue&type=script&lang=ts"
export * from "./AppBarStart.vue?vue&type=script&lang=ts"
import style0 from "./AppBarStart.vue?vue&type=style&index=0&id=4da7f495&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da7f495",
  null
  
)

export default component.exports